<template>
  <div id="manuscript-question">
    <div>
      <ipub-row :gutter="30">
        <ipub-col v-for="(item,index) in questionList"
                  :key="item.questionId"
                  :span="6">
          <div class="mar-b-10">
            <div class="ipub-p2 mar-b-4">
              <font v-if="item.required">{{index+1}}. </font>{{item.questionContent}}
            </div>
            <div v-if="item.type === 'QA'">
              <ipub-input v-model.trim="item.answer"
                          :disabled="true"
                          placeholder="Input your answer" />
            </div>
            <div v-else-if="item.type === 'SINGLE'">
              <ipub-radio-group v-model="item.checkedOption"
                                :options="JSON.parse(item.questionOption)">
                <ipub-radio v-for="(val, num) in JSON.parse(item.questionOption)"
                            :value="num.toString()"
                            :disabled="!(num.toString()===item.checkedOption)"
                            style="margin-right:40px;margin-bottom:8px;margin-left:0;font-color:link-color"
                            :key="val.answer + num">
                  <span :class="num.toString()===item.checkedOption?'font-color':''">{{val.answer}}</span>
                </ipub-radio>
              </ipub-radio-group>
              <div v-if="(item.checkedOption || item.checkedOption===0) && JSON.parse(item.questionOption)[item.checkedOption].supplementary"
                   style="margin-top: 10px">
                <div class="ipub-p2 mar-b-10">
                  {{JSON.parse(item.questionOption)[item.checkedOption].supplementary}}
                </div>
                <div>
                  <ipub-input v-model.trim="item.supplyAnswer"
                              :disabled="true"
                              placeholder="Input your answer" />
                </div>
              </div>
            </div>
            <div v-else-if="item.type === 'MULTIPLE'">
              <ipub-radio-group checkBox
                                v-model="item.checkedOption">
                <ipub-radio checkBox
                            :disabled="!(item.checkedOption.includes(val.answer))"
                            v-for="(val, num) in JSON.parse(item.questionOption)"
                            :value="val.answer"
                            style="margin-bottom:8px"
                            :key="val.answer + num">
                  {{val.answer}}
                </ipub-radio>
              </ipub-radio-group>
            </div>
          </div>
        </ipub-col>
      </ipub-row>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    questionList: {
      type: [Object, Array],
      default () {
        return {}
      },
    },
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
#manuscript-question {
  .part {
    background: $content_color;
    border-radius: 4px;
    padding: 4px 16px;
  }
  // .ipub-radio__checkBox--disabled.ipub-radio__radio--checked[data-v-375a79d0]:hover::after,
  // .ipub-radio__radio--disabled.ipub-radio__radio--checked[data-v-375a79d0]:hover::after
  .ipub-radio {
    &__radio {
      &--checked {
        &::after {
          background: #005acd;
        }
      }
    }
  }
}
</style>